export default class ExportTpClientInvoicePdfsItem {
  constructor() {
    this.LatestVersion = null;
  }
}
